module.exports = __webpack_public_path__ + "static/media/finished_white.19e104a5.svg";